import dynamic from 'next/dynamic';

import type { FunctionComponent } from 'react';
import type { TypeEmptyProps } from './types';

const EmptyCart = dynamic(() => import('@/assets/images/EmptyCart.svg'), {
  ssr: false,
});

/**
 * Empty
 */
export const Empty: FunctionComponent<TypeEmptyProps> = ({
  className = '',
  title,
  text,
  showIcon = true,
  children,
}: TypeEmptyProps) => (
  <div
    className={`flex flex-col-reverse items-center gap-7 md:flex-row ${className}`}
  >
    <div className="flex w-[375px] flex-col items-center text-center md:items-start md:text-left">
      {title && (
        <span className="u-headline u-headline--h1 mb-4 block">{title}</span>
      )}
      {text && (
        <p className="u-body u-body--s mb-4 text-typo-secondary md:mb-8">
          {text}
        </p>
      )}
      {children}
    </div>

    {showIcon && <EmptyCart className="opacity-40" />}
  </div>
);
